/**
* 登录
*/
const login = {
  
login: "/api/login",//登录
logout: "/api/logout",//登出
bindCompanyOfCurrentSession: "/api/bindCompanyOfCurrentSession",//绑定当前会话的公司
}

export default login